import React, { useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getDppContent } from 'Api/DppApi';
import { parseDppContent } from 'Utils/Content';
import {
  ButtonCTA,
  EmailAlert,
  ExclusiveContent,
  FAQ,
  Packages,
  Perks,
  ShowsGrid,
  Hero,
} from 'Components/FreeFormPanels';
import { ErrorBoundary } from 'Components/ErrorBoundary/ErrorBoundary';
import { updateScreen } from 'State/FreeForm/FreeFormActions';
import { logger } from 'Utils/Logger';
import './FreeLayout.css';

export const FreeLayoutComponent = ({ screenName, className }) => {
  const dispatch = useDispatch();
  const location = useLocation();

  const freeForm = useSelector((s) => s.freeForm);

  const freeFormPanelList = useMemo(
    () => ({
      ButtonCTA,
      EmailAlert,
      ExclusiveContent,
      FAQ,
      Packages,
      Perks,
      ShowsGrid,
      Hero,
    }),
    []
  );

  useEffect(() => {
    if (screenName) {
      logger.started('free layout content', screenName);
      getDppContent(screenName)
        .then((member) => {
          if (member && member.length > 0) {
            const content = parseDppContent(member);
            dispatch(updateScreen(screenName, content));
            logger.completed('free layout content', { screenName, content });
          }
        })
        .catch((error) => {
          logger.error('free layout content', screenName, error);
        });
    }
  }, [dispatch, screenName]);

  if (screenName) {
    return (
      <div className={`freeLayout ${className || ''}`}>
        {freeForm &&
          freeForm[screenName] &&
          freeForm[screenName].content &&
          freeForm[screenName].content.map((data, index) => {
            const Panel = freeFormPanelList[data.component] ? freeFormPanelList[data.component] : null;
            const idx = data.component + index;
            return (
              Panel && (
                <ErrorBoundary key={idx} name="freeform layout">
                  <Panel key={idx} {...data.panelProps} screenName={screenName} location={location} />
                </ErrorBoundary>
              )
            );
          })}
      </div>
    );
  }
  return null;
};

export default FreeLayoutComponent;
